module.exports = __webpack_public_path__ + "static/bg-noinvite.4549396c.png";